import { Chart } from '@frontend/chart/types';

import { formatChartSeriesName } from './format-chart-series-name';
import { normalizeChartDateLabel } from './to-weekday-week-heatmap-series';

export const toApexAxisChartSeries = (chart: Chart, unknownLabel: string): ApexAxisChartSeries =>
    (chart.series ?? []).map((series) => ({
        name: formatChartSeriesName(series.name, unknownLabel) ?? '',
        data: (series.data ?? []).map((point) => point.value)
    }));

export const toApexCategories = (chart: Chart): string[] =>
    (chart.series[0]?.data ?? []).map((point) => {
        const normalized = normalizeChartDateLabel(point.label);
        return normalized ?? String(point.label ?? '');
    });

export const toApexPieSeries = (chart: Chart): { series: number[]; labels: string[] } => {
    const chartSeries = chart.series ?? [];
    const single = chartSeries.length === 1 ? chartSeries[0] : null;
    // Point labels only when one breakdown series has multiple category points (or no series name).
    // Group-by pies use series.name as the category — even when there is only one series.
    const usePointLabels = single != null && (single.name == null || String(single.name).trim() === '' || (single.data?.length ?? 0) > 1);

    if (!usePointLabels) {
        return {
            series: chartSeries.map((series) => (series.data ?? []).reduce((sum, point) => sum + point.value, 0)),
            labels: chartSeries.map((series) => String(series.name ?? series.data?.[0]?.label ?? ''))
        };
    }

    const points = single?.data ?? [];

    return {
        series: points.map((point) => point.value),
        labels: points.map((point) => String(point.label ?? ''))
    };
};
